import shallowEqual from './shallow-equal'

export default {
  shallowEqual
}

export {
  shallowEqual
}
